import {
  type Column,
  flexRender,
  type HeaderGroup,
} from '@tanstack/react-table';
import { Fragment } from 'react';
import { Tooltip } from '../../tooltip/Tooltip';
import { type AppTableFeatures } from '../react-table-features';
import { StickyTableHeader } from '../sticky-table-header/StickyTableHeader';
import type { PinConfig } from '../table-cell/TableCell';
import { TableHeader } from '../table-header/TableHeader';
import styles from './RevampTable.module.scss';
import type { RevampTableRow } from './RevampTable.types';
import { getRevampTableCellAlignment, isRevampTableColumn } from './utils';

interface RevampTableHeaderRowProps {
  getPinConfig: (
    column: Column<AppTableFeatures, RevampTableRow>
  ) => PinConfig | undefined;
  headerGroup: HeaderGroup<AppTableFeatures, RevampTableRow>;
  stickyHeader?: boolean;
}

export const RevampTableHeaderRow = ({
  getPinConfig,
  headerGroup,
  stickyHeader,
}: RevampTableHeaderRowProps) => (
  <tr>
    {headerGroup.headers.map(header => {
      const content = flexRender(
        header.column.columnDef.header,
        header.getContext()
      );
      const meta = header.column.columnDef.meta;

      if (!isRevampTableColumn(meta)) {
        return null;
      }

      const alignment = getRevampTableCellAlignment(meta);
      const pinConfig = getPinConfig(header.column);
      const headerCell =
        stickyHeader || pinConfig ? (
          <StickyTableHeader
            alignment={alignment}
            className={styles.headerCell}
            isHoverEnabled={false}
            pinConfig={pinConfig}
          >
            {content}
          </StickyTableHeader>
        ) : (
          <TableHeader
            alignment={alignment}
            className={styles.headerCell}
            isHoverEnabled={false}
          >
            {content}
          </TableHeader>
        );

      return (
        <Fragment key={header.id}>
          {meta.tooltip ? (
            <Tooltip inPortal label={meta.tooltip}>
              {headerCell}
            </Tooltip>
          ) : (
            headerCell
          )}
        </Fragment>
      );
    })}
  </tr>
);
